import SavedMarketStateFilter from '@app/model/market_state/_saved_filters/SavedMarketStateFilter';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	COUNT_MY_SAVED_MARKET_STATE_FILTERS_QUERY,
	CREATE_MARKET_STATE_FILTER_MUTATION, FIND_DEFAULT_MARKET_STATE_FILTER_QUERY,
	FIND_MY_SAVED_MARKET_STATE_FILTERS_QUERY, MAKE_DEFAULT_MARKET_STATE_FILTER_MUTATION,
	REMOVE_MARKET_STATE_FILTER_MUTATION,
} from '@app/model/market_state/_saved_filters/service/SavedMarketStateFilterGraphQLQueries';
import SavedMarketStateFilterFilter from '@app/model/market_state/_saved_filters/SavedMarketStateFilterFilter';

export class SavedMarketStateFilterService {

	public static async countMySavedMarketStateFilters(companyHotelId: number): Promise<number> {
		return GraphQLExecutor.execute<number>(COUNT_MY_SAVED_MARKET_STATE_FILTERS_QUERY, { companyHotelId });
	}

	public static async findMySavedMarketStateFilters(companyHotelId: number): Promise<SavedMarketStateFilter[]> {
		return GraphQLExecutor.execute<SavedMarketStateFilter[]>(FIND_MY_SAVED_MARKET_STATE_FILTERS_QUERY, { companyHotelId });
	}

	public static async findDefaultMarketStateFilter(companyHotelId: number): Promise<SavedMarketStateFilter> {
		return GraphQLExecutor.execute<SavedMarketStateFilter>(FIND_DEFAULT_MARKET_STATE_FILTER_QUERY, { companyHotelId });
	}

	public static async createSavedMarketStateFilter(variables: {companyHotelId: number, name: string, filter: SavedMarketStateFilterFilter}): Promise<SavedMarketStateFilter[]> {
		return GraphQLExecutor.execute<SavedMarketStateFilter[]>(CREATE_MARKET_STATE_FILTER_MUTATION, variables);
	}

	public static async removeSavedMarketStateFilter(variables: {companyHotelId: number, id: number}): Promise<SavedMarketStateFilter[]> {
		return GraphQLExecutor.execute<SavedMarketStateFilter[]>(REMOVE_MARKET_STATE_FILTER_MUTATION, variables);
	}

	public static async makeDefaultSavedMarketStateFilter(variables: {companyHotelId: number, id: number}): Promise<SavedMarketStateFilter[]> {
		return GraphQLExecutor.execute<SavedMarketStateFilter[]>(MAKE_DEFAULT_MARKET_STATE_FILTER_MUTATION, variables);
	}
}